import { Button, Modal, Typography } from 'antd';
import {ExclamationCircleFilled} from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import '../../../styles/components/MarketPlace/MarketplaceModals.scss';
import { Routes } from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import { jobTypes } from '../../../constants/MarketplaceConstants';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const {Text} = Typography;

function DuplicateApplicationPopup({open,close, jobType='', accessOrigin, company}) {
  const history = useHistory();
  const {t} = useTranslation();

    const moveToJobListings = () => {
      if (accessOrigin === 'JobCard') {
         // since the modal's action button re-opens the same page, just close the modal instead of page reload
        window.scrollTo(0, 0)
        close();
      } else {
        history.replace(`${Routes.JOB_LISTINGS}?city=${localStorage.getItem('preferredLocation')}`);
      }
    };

    const [modalInfo, setModalInfo] = useState({});

    useEffect(() => {
      if (jobType === jobTypes.COMING_SOON) {
        const information = {};
        information.unavailableText = t('coming_soon_unavailable_text');
        information.otherOpportunityText = t('coming_soon_others_op');
        setModalInfo(information);
      } else {
        const information = {};
        information.unavailableTextPre = t('applied_unavailable_text_pre');
        information.unavailableTextPost = t('applied_unavailable_text_post');
        information.otherOpportunityText = t('applied_others_op');
        information.dontWorry = t('dont_worry');
        setModalInfo(information);
      }
    }, [])
    
  return (
    <Modal
        closable={false}
        visible={open}
        // onCancel={close}
        footer={null}
        className="unapplicable-jobs-modal"
      >
        <div className='duplicate-application-popup'>
            <div className='exclamation-container'>
                <ExclamationCircleFilled style={{fontSize:'40px', color:'#D34B18'}}/>
                <Text className='highlighted-information'>
                  {
                    jobType === jobTypes.COMING_SOON ? 'Stay Tuned!': 'Oh! Ho!'
                  }
                </Text>
            </div>
            <Text className='unavailable-job-text'>
                {modalInfo?.unavailableTextPre} {company} {modalInfo?.unavailableTextPost}
            </Text>
            
            <Text className='other-op-text'>
                {modalInfo.dontWorry ? <Text style={{fontWeight: 700}}>{modalInfo?.dontWorry}</Text>: null}
                {modalInfo?.otherOpportunityText}
            </Text>
            <Button className='get-started-button primary-cta' onClick={moveToJobListings}>
                <Text className='get-started-text'>View Other Jobs</Text>
            </Button>
        </div>
    </Modal>
  )
}

export default DuplicateApplicationPopup
